import {
    CancelOutlined,
    CancelRounded,
    Delete,
    ErrorOutline,
    KeyboardArrowDown,
  } from "@mui/icons-material";
  import {
    Button,
    CircularProgress,
    Dialog,
    InputBase,
    MenuItem,
    Select,
  } from "@mui/material";
  import axios from "axios";
  import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
  
  const RemoveChannelModal = ({ open, setOpen, setChannels, channel_data, closeMenu,index }) => {
    let org = JSON.parse(localStorage.getItem("organization"))
    const [loader, setLoader] = useState(false);
    const [error_msg, setErrormsg] = useState(null);
    const [channel, setChannel] = useState({
      channel_id: channel_data.ch_id.S,
      organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
    });
  
    const [call_routes, setCallRoutes] = useState(null)
  
    const [authenticationcode, setauthenticationcode] = useState("");
  const getRoutes = async() => { 
    setLoader(true)
     console.log('channel',channel_data)
     console.log('hi')
       let routes = await axios.post(
           process.env.REACT_APP_BACKEND_URL + "route/get-routes-using-multiple-params",
           {
               primaryChannel:  channel_data.ch_id.S,
               org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
               offHoursChannel:  channel_data.ch_id.S,
               primaryNumber : channel_data.value.S,
           }
         );
         console.log('routes',routes.data.routes)
   
         setCallRoutes(routes.data.routes)
         setLoader(false)
   }
  
  useEffect(() => {
    getRoutes(
    )
  }, [channel_data])
  
   
    
  
    const deleteChannel = async () => {
        let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                        userId: JSON.parse(localStorage.getItem('user')).userId.S
                    });
                    
                    if (check.status ===200) {
                      const user___ = check.data.user;
                      
                
                      if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
                        try {
                          setLoader(true);
                    
                          let channel_data = await axios.post(
                            process.env.REACT_APP_BACKEND_URL + "delete-channel",
                            channel
                          );
                    
                          console.log(channel_data);
                    
                          localStorage.setItem(
                            "organization",
                            JSON.stringify(channel_data.data.updatedItem)
                          );
                    
                          setChannels(channel_data.data.updatedItem.channels.L);
                          setOpen(false);
                          setLoader(false);
                          setErrormsg(null);
                          closeMenu(index)
                        } catch (error) {
                          console.log(error);
                          if (error.response && error.response.data) {
                            console.error("Response data:", error.response.data);
                            setErrormsg(error.response.data.message);
                          }
                          setLoader(false);
                        }
                          
                      }else{
                        window.location.reload()
                      }
            
                    }
    };

    useEffect(() => {
      const globalKeyListener = (e) => {
        console.log("Global key event:", e.key);

            if (e.key ===  'd' || e.key ===  'D' || e.key ===  'E' || e.key ===  'e') {
                // Manually update the input value with 'd'
                setauthenticationcode((prevValue) => prevValue + e.key);
                // Prevent the default action of the 'd' key
                document.getElementById('input').focus()
                e.preventDefault();
              }
        }
    
      document.addEventListener("keydown", globalKeyListener);
    
      return () => {
        document.removeEventListener("keydown", globalKeyListener);
      };
    }, []);

    const navigate = useNavigate()
  
    return (
      <Dialog
        open={open}
        fullWidth={true}
        maxWidth={"sm"}
        BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
      >
        <div className="px-8 py-6">
          <div className="relative">
            <div className="lg:text-[20px] text-[18px] text-center  font-semibold mb-2">
              {" "}
              Are you sure?
            </div>
            <div className="absolute top-0 right-0">
              <CancelRounded
                sx={{ color: "#E71D36", cursor: "pointer", fontSize: "20px  " }}
                onClick={() => setOpen(false)}
              />
            </div>
          </div>
          {error_msg && (
            <div className=" text-red-500 lg:text-[13px] text-[12px] mb-2  font-semibold ">
              <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
            </div>
          )}
  
        {(call_routes && call_routes.length > 0) && (
            <div className="lg:text-[15px] text-[14px] text-center mt-2   mb-4">
            You have {call_routes && call_routes.length} call routes 
            ({call_routes.filter((e) => e)
  .map((e, index) => (
    <span onClick={()=> navigate('/dashboard/call-route/'+e.routeId.S) } key={index} className="text-blue-700 hover:underline cursor-pointer">
      {e.name.S}
    </span>
  ))
  .reduce((prev, curr) => [prev, ', ', curr])}) 
            currently using this channel. Please remove these dependencies before deleting this channel.
          </div>
        )}
  
          <div hidden = {call_routes && call_routes.length > 0 ? true : false} className="lg:w-full my-3">
          <InputBase
            id='input'
              placeholder="Type DELETE to Confirm"
              value={authenticationcode}
              onChange={(e) => {
                console.log("Input value:", e.target.value);
                setauthenticationcode(e.target.value)
              }
                
              }
              sx={{
                bgcolor: "#F7F7F8",
                width: "100%",
                px: 2,
                py: 1,
                fontSize: { lg: "16px", xs: "14px" },
              }}
            />
          </div>
          <div className="flex justify-center">
            <div className="space-y-5 ">
              <div className="flex justify-center pt-6 pb-4 space-x-2">
                <Button
                  sx={{
                    textTransform: "none",
                    color: "#605BFF",
                    bgcolor: "white",
                    py: "4px",
                    px: "40px",
                    borderRadius: "7px",
                    border: "1px solid rgba(96,91,255,0.1)",
                    fontSize: { lg: "14px", xs: "12px" },
                  }}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Cancel
                </Button>
  
                {call_routes && call_routes.length > 0 ? (<></>) : (
                    <Button
                    sx={{
                      textTransform: "none",
                      bgcolor: "rgba(236,72,92,0.1)",
                      color: "rgba(236,72,92,1)",
                      py: "4px",
                      px: "40px",
                      borderRadius: "7px",
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                    disabled={authenticationcode ===  "DELETE" ? false : true}
                    onClick={() => {
                      deleteChannel();
                    }}
                  >
                    {loader ? (
                      <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                    ) : (
                      " Delete"
                    )}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    );
  };
  
  export default RemoveChannelModal;
  